import { StatusLabel } from 'components/common-form/sidePanel/status/initialized/StatusLabel';
import { FC } from 'react';

export const Ready: FC<{}> = () => <StatusLabel labelKey="addon.sidePanel.status.ready" color="info" />;
Ready.displayName = 'Ready';
